import { useContext } from 'react';
import QRCode from 'react-qr-code';
import clsx from 'clsx';

import { IProps } from '../../interfaces/components/qrCode.interface';
import { SelectionsContext } from '../../contexts/Selections';

const QrCode = ({ value, className }: IProps) => {
  const selectionsContext = useContext(SelectionsContext);

  const values: Record<string, string | undefined> = {
    vehicleToPair: selectionsContext?.vehicleToPair?.virtualKeyUrl,
  };

  return (
    <div className={clsx('qr-code-container', className)}>
      <QRCode
        value={values[value] || value}
        style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
      />
    </div>
  );
};

export default QrCode;
